(function () {
  if (window.__pdpDimensionsLightboxBound) return;
  window.__pdpDimensionsLightboxBound = true;

  var lastDimensionsTrigger = null;

  function findDimensionsContent() {
    return document.querySelector(
      '.product-tabs .specifications-content-wrapper, ' +
      '.section-product-tabs .specifications-content-wrapper'
    );
  }

  function getLightboxFromTrigger(trigger) {
    if (!trigger) return null;

    var lightboxId = trigger.getAttribute('aria-controls');

    if (lightboxId) {
      return document.getElementById(lightboxId);
    }

    var component = trigger.closest('.product-dimensions');

    if (component) {
      return component.querySelector('[data-dimensions-lightbox]');
    }

    return document.querySelector('[data-dimensions-lightbox]');
  }

  function removeImageLinks(clone) {
    var imageLinks = clone.querySelectorAll(
      'a.dimension-modal-trigger'
    );

    imageLinks.forEach(function (link) {
      var parent = link.parentNode;

      if (!parent) return;

      while (link.firstChild) {
        parent.insertBefore(link.firstChild, link);
      }

      parent.removeChild(link);
    });
  }

  function openDimensionsLightbox(trigger) {
    var sourceContent = findDimensionsContent();
    var lightbox = getLightboxFromTrigger(trigger);

    if (!sourceContent || !lightbox) {
      console.warn(
        'Dimensions & Details content or lightbox was not found.'
      );
      return;
    }

    var lightboxContent = lightbox.querySelector(
      '[data-dimensions-lightbox-content]'
    );

    if (!lightboxContent) {
      console.warn(
        'Dimensions & Details lightbox content area was not found.'
      );
      return;
    }

    lightboxContent.innerHTML = '';

    var clone = sourceContent.cloneNode(true);

    removeImageLinks(clone);

    lightboxContent.appendChild(clone);

    lastDimensionsTrigger = trigger;

    lightbox.removeAttribute('hidden');
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');

    trigger.setAttribute('aria-expanded', 'true');

    document.body.classList.add(
      'pdp-dimensions-lightbox-open'
    );

    var closeButton = lightbox.querySelector(
      '.pdp-dimensions-lightbox__close'
    );

    if (
      closeButton &&
      typeof closeButton.focus === 'function'
    ) {
      closeButton.focus({
        preventScroll: true
      });
    }
  }

  function closeDimensionsLightbox(lightbox) {
    if (!lightbox) return;

    var lightboxContent = lightbox.querySelector(
      '[data-dimensions-lightbox-content]'
    );

    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    lightbox.setAttribute('hidden', '');

    document.body.classList.remove(
      'pdp-dimensions-lightbox-open'
    );

    if (lightboxContent) {
      lightboxContent.innerHTML = '';
    }

    if (lastDimensionsTrigger) {
      lastDimensionsTrigger.setAttribute(
        'aria-expanded',
        'false'
      );

      if (
        typeof lastDimensionsTrigger.focus === 'function'
      ) {
        lastDimensionsTrigger.focus({
          preventScroll: true
        });
      }

      lastDimensionsTrigger = null;
    }
  }

  document.addEventListener('click', function (event) {
    var target = event.target;

    if (!(target instanceof Element)) return;

    var openTrigger = target.closest(
      '[data-open-dimensions-lightbox]'
    );

    var closeTrigger = target.closest(
      '[data-close-dimensions-lightbox]'
    );

    /*
     * Find the currently open lightbox rather than the first
     * lightbox on the page.
     */
    var lightbox = document.querySelector(
      '[data-dimensions-lightbox].is-open'
    );

    var panel = lightbox
      ? lightbox.querySelector(
          '.pdp-dimensions-lightbox__panel'
        )
      : null;

    if (openTrigger) {
      event.preventDefault();
      openDimensionsLightbox(openTrigger);
      return;
    }

    /*
     * Closes from either:
     * - the X button
     * - the overlay element
     */
    if (closeTrigger) {
      event.preventDefault();

      closeDimensionsLightbox(
        closeTrigger.closest(
          '[data-dimensions-lightbox]'
        ) || lightbox
      );

      return;
    }


    if (
      lightbox &&
      panel &&
      lightbox.contains(target) &&
      !panel.contains(target)
    ) {
      closeDimensionsLightbox(lightbox);
    }
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    var lightbox = document.querySelector(
      '[data-dimensions-lightbox].is-open'
    );

    closeDimensionsLightbox(lightbox);
  });
})();